import { FundingSourceType, PayorPaymentRequestDetails } from '@melio/ar-domain';
import { Group } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { FundingSourceSelection, PaymentRequestDetailsHeader, PCIComplianceInfo } from '../components';
import { NewGuestPaymentLayout } from './NewGuestPayment.layout';

export type PaymentLayoutProps = {
  isLoading: boolean;
  payeeDetails: PayorPaymentRequestDetails;
  onViewInvoice: VoidFunction;
  onSelectFundingSource: (fundingSource: FundingSourceType) => void;
  selectedFundingSource?: FundingSourceType;
};

export const PaymentLayout = forwardRef<PaymentLayoutProps>(
  ({ onViewInvoice, selectedFundingSource, onSelectFundingSource, payeeDetails, isLoading }, ref) => {
    const hasAllPaymentMethods =
      payeeDetails.invoice.paymentOptions.isCardAllowed && payeeDetails.invoice.paymentOptions.isAchAllowed;

    const hasSomePaymentMethod =
      payeeDetails.invoice.paymentOptions.isCardAllowed || payeeDetails.invoice.paymentOptions.isAchAllowed;

    return (
      <NewGuestPaymentLayout isLoading={isLoading} data-component={PaymentLayout.displayName} ref={ref}>
        <Group variant="vertical">
          <Group variant="vertical" spacing="l" hasDivider>
            <PaymentRequestDetailsHeader
              payeePaymentRequestDetails={payeeDetails.payeeDetails}
              invoicePaymentRequestDetails={payeeDetails.invoice}
              onViewInvoice={onViewInvoice}
            />
            {hasAllPaymentMethods ? (
              <Group variant="vertical" spacing="m">
                <FundingSourceSelection
                  selectedFundingSource={selectedFundingSource}
                  onCardSelected={() => onSelectFundingSource('card')}
                  onBankSelected={() => onSelectFundingSource('bank-account')}
                />
                <Outlet />
              </Group>
            ) : (
              <Outlet />
            )}
          </Group>
          {hasSomePaymentMethod ? <PCIComplianceInfo /> : null}
        </Group>
      </NewGuestPaymentLayout>
    );
  }
);

PaymentLayout.displayName = 'PaymentLayout';
